import React, { Component, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { 
    setCheckoutTitle, 
    setCheckoutSubtitle,
    setCheckoutNextCallback
} from 'store';

import { gtmPush } from 'helpers';

import FileUpload from './FileUpload';
import Notes from './Notes';

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    padding: 30px 0;
`;

class Diploma extends Component {

    constructor() 
    {
        super();
    }

    componentDidMount()
    {
        this.props.setCheckoutTitle('Vedlegg');
        this.props.setCheckoutSubtitle('');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Vedlegg',
            'pageURI': '/checkout/vedlegg', 
        });
    }

    _onSubmit() {
        const fileUploadResult = this.fileUploadRef._onSubmit();

        if (false === fileUploadResult) {
            return Promise.resolve(false);
        }

        const fileUploadPromise = (fileUploadResult && typeof fileUploadResult.then === 'function')
            ? fileUploadResult
            : Promise.resolve(fileUploadResult);

        return fileUploadPromise.then(isFileUploadValid => {
            if (false === isFileUploadValid) {
                return false;
            }

            // Propagate Notes result (true/false). Do not force true on create/update failure,
            // otherwise checkout advances to Cachier and triggers PUT /opportunities/null.
            return this.noteRef._onSubmit();
        });
    }

    render()
    {
        return(
            <Container>
                <Row>
                    <FileUpload onRef={ref => (this.fileUploadRef = ref)} />
                </Row>
                <Row>
                    <Notes onRef={ref => (this.noteRef = ref)} />
                </Row>  
            </Container>
        )
    }

}

const mapStateToProps = state => ({

});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback
}

export default connect(mapStateToProps, actions)(Diploma);


// WEBPACK FOOTER //
// ./src/partials/Checkout/Diploma.js